// Activate Code
export const ACTIVATE_CODE_REQUEST = 'ACTIVATE_CODE_REQUEST';
export const ACTIVATE_CODE_DONE = 'ACTIVATE_CODE_DONE';
export const ACTIVATE_CODE_FAILED = 'ACTIVATE_CODE_FAILED';
